import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { AnalysisRequestComponent } from '../dashboard/analysis-request/analysis-request.component';
import { MatDialog } from '@angular/material/dialog';
import { IPatient } from '../dashboard/patient/patient.interface';
import { MyReportsService } from './my-reports.service';
import { SnackBarService } from 'src/app/framework/service/snack-bar.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { forkJoin } from 'rxjs';
import { IDocViewerConfig } from 'src/app/features/shared/components/report-viewer/doc-viewer.config';
@Component({
  selector: 'app-my-reports',
  templateUrl: './my-reports.component.html',
  styleUrls: ['./my-reports.component.scss']
})
export class MyReportsComponent implements OnInit {
  patient: IPatient | null = null;
  id: number | null = null;
  isAnalysisRequestedStatus: Boolean = false;
  isLoading: boolean = true;
  patientReport: any;
  patientReportFilterBy = { keyword: "" };
  patientReportPageIndex = 0;
  dataSource = new MatTableDataSource();
  pageSize = 12;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;
  isContentAvailable: Boolean = true;
  templateId: number;
  isOpenContent1: Boolean = true;
  sampleSNPPickerCsvPath: any;
  isOpenContent: Boolean = false;
  module: any;
  config: IDocViewerConfig;

  constructor(
    private readonly router: Router,
    private readonly myReportsService: MyReportsService,
    private readonly route: ActivatedRoute,
    private readonly dialog: MatDialog,
    private readonly snackBarService: SnackBarService,
    private readonly snackBar: SnackBarService
  ) { }

  ngOnInit(): void {
    this.getAndSetPatientId();
    this.myReportsService.analysisRequested.subscribe((flag) => {
    if (flag) {
      this.getAndSetPatientId();
    }
  });
  }

  private getAndSetPatientId(): void {
    this.myReportsService.getPatientbyId().subscribe(
      (data) => {
        if (data) {
          this.id = data;
          this.patient = data;

          this.router.navigate([], {
            relativeTo: this.route,
            queryParams: { id: this.id },
            queryParamsHandling: 'merge',
          });

          this.fetchPatientDetails(this.id);
        } else {
          this.patient = null;
          this.isLoading = false;
        }
      },
      (error) => {
        this.snackBarService.error(error.error?.applicationMessage || 'Failed to fetch patient ID.');
        this.isLoading = false;
      }
    );
  }

  private fetchPatientDetails(id: number): void {
    if (!this.patient) {
      this.isLoading = false;
      return;
    }
    this.myReportsService.getPatientAnalysisRequestStatus(this.id).subscribe(
      (data) => {
        this.isAnalysisRequestedStatus = this.patient && data.hasAnalysisRequested || data.totalAnalysisReportsPresent > 0;
        this.findPatientReportDetails();
        this.isLoading = false;
      },
      (error) => {
        this.snackBarService.error(error.error.applicationMessage);
        this.isLoading = false;
      }
    );
  }

  addAnalysisRequest(): void {
    if (!this.patient) return;

    const dialogRef = this.dialog.open(AnalysisRequestComponent, {
      width: '630px',
      height: '400px',
      disableClose: true,
      autoFocus: false,
      data: { patientId: this.patient },
    });
  }

  private findPatientReportDetails() {
    this.patientReportFilterBy["patientId"] = this.id;
    this.myReportsService
      .findAllPatientReport(
        this.patientReportPageIndex,
        this.patientReportFilterBy
      )
      .subscribe((data) => {
        this.reorderReportsByReleaseStatus(data);
        this.dataSource.data = data.content;

        if (this.paginator) {
          this.paginator.length = data.totalElements;
        }

        this.dataSource.sort = this.sort;
        this.getTemplateDetails(data);
        this.patientReport = data;

        if (data.content.length === 0) {
          this.isContentAvailable = false;
        }

        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
  }

  getTemplateDetails(data) {
    if (!data.content || data.content.length === 0) return;

    const templateRequests = data.content.map((resp: any) =>
      this.myReportsService.getTemplateDetails(resp.templateId)
    );

    forkJoin(templateRequests).subscribe((templates: any[]) => {
      templates.forEach((template, index) => {
        data.content[index]["templateName"] = template.templateName;
        data.content[index]["refTemplateType"] = template.refTemplateType.description;
      });

      this.dataSource.data = [...data.content];
    });
  }

  pageChange(event) {
    this.myReportsService
      .findAllPatientReport(event.pageIndex, this.patientReportFilterBy)
      .subscribe((data) => {
        this.reorderReportsByReleaseStatus(data);
        this.getTemplateDetails(data);
        this.patientReport = data;
        this.scrollContainer.nativeElement.scrollTop = 0;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
  }

  private reorderReportsByReleaseStatus(data: { content?: { isReleased?: boolean }[] }): void {
  if (!data?.content?.length) return;

  const released: typeof data.content = [];
  const notReleased: typeof data.content = [];

  for (const report of data.content) {
    (report.isReleased ? released : notReleased).push(report);
  }

  data.content = [...released, ...notReleased];
}

  private download(blob: Blob, name: string) {
    const a = document.createElement("a");
    document.body.appendChild(a);
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    const filename = name;
    a.download = filename;
    a.target = "_blank";
    const event = new MouseEvent("click", {
      view: window,
      bubbles: false,
      cancelable: true,
    });
    a.dispatchEvent(event);
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }, 0);
  }

  setRepotUrl(reportPdfPath) {
    this.myReportsService
      .download(reportPdfPath)
      .subscribe((rsp: any) => {
        const doc: any = new Blob([rsp.body], {
          type: rsp.headers.get("Content-Type"),
        });
        this.module = { blob: doc };
      });
  }

  closeContent() {
    this.findPatientReportDetails();
    this.isOpenContent1 = true;
    this.isOpenContent = false;
  }

  viewReport(patientId, templateId, csvPath, reportPdfPath, customName) {
    this.myReportsService.downloadReportFile(reportPdfPath, customName).subscribe(resp => {
      this.myReportsService.viewReport(patientId, templateId).subscribe((data) => {
        this.findPatientReportDetails();
        this.config = docConfig;
        this.setRepotUrl(data.reportPdfPath);
        this.isOpenContent = true;
        this.isOpenContent1 = false;
        this.sampleSNPPickerCsvPath = csvPath;
        this.templateId = templateId;
      });
    }, error => {
      this.snackBarService.error(error);
    });
  }

  downloadTemplateReport(reportPdfpath, customName) {
    const url = reportPdfpath;
    this.myReportsService.downloadReportFile(url, customName).subscribe(resp => {
      const blob: any = new Blob([resp.body], {
        type: resp.headers.get("Content-Type"),
      });
      this.download(blob, resp.headers.get("X-Doc-Name"));
      this.snackBar.success("Success! Your report has been downloaded");
    }, error => {
      this.snackBarService.error(error);
    });
  }

  isReportEnabled(report: any): boolean {
    const id = report?.refGenomeStatus?.identifier?.toString();
    return id === "1" && report?.isReleased === true;
  }
  
  isReportReleased(report: any): boolean {
    return this.isReportEnabled(report);
 }
}

const docConfig: IDocViewerConfig = {
  showDownloadButton: false,
  showPrintButton: true,
  showOpenFileButton: false,
  showBookmarkButton: false,
  showSidebarButton: false,
  showSecondaryToolbarButton: false,
  showPresentationModeButton: true,
};
  
